import styled from "styled-components"
import Breakpoints from "../../../components/shared/breakpoints"
import { T } from "../../styles/typography"

export const Heading1 = styled.h1`
  grid-column: 1/-1;
  ${T.sm.h1(500)}
  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h1(500)};
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h1(500)};
  }
`

export const Heading2 = styled.h2`
  grid-column: 1/-1;
  ${T.sm.h2(500)}
  :not(:last-child) {
    margin-bottom: 24px;
  }

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h2(500)}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h2(500)}
  }
`

export const Heading3 = styled.h3`
  grid-column: 1/-1;
  ${T.sm.h3(500)}
  :not(:last-child) {
    margin-bottom: 24px;
  }
  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h3(500)}
    margin-bottom: 16px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h3(500)}
    margin-bottom: 24px;
  }
`

export const Heading4 = styled.h4`
  grid-column: 1/-1;
  ${T.sm.h4(500)}

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h4(500)}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h4(500)}
  }
`

export const Heading5 = styled.h5`
  grid-column: 1/-1;
  ${T.sm.h5(500)}

  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h5(500)}
  }
`

export const Paragraph = styled.p`
  grid-column: 1/-1;
  ${T.sm.body(400)};
  :not(:last-child) {
    margin-bottom: 24px;
  }
  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body(400)};
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body(400)};
  }
`

export const Bold = styled.strong`
  font-weight: 500;
`
export const Italic = styled.em`
  font-style: italic;
`
export const Underline = styled.u`
  font-style: underline;
`

export const UnorderedList = styled.ul`
  :not(:first-child) {
    margin-top: 32px;
  }
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 48px;
  }
`

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  text-align: left;

  svg {
    width: 30px;
    height: 30px;
    margin-right: 16px;
    flex-shrink: 0;
    display: inline-block;
    vertical-align: top;
    @media (min-width: ${Breakpoints.md}) {
      width: 24px;
      height: 24px;
    }
    @media (min-width: ${Breakpoints.lg}) {
      width: 30px;
      height: 30px;
    }
  }
`

export const StaticImage = styled.img`
  :not(:last-child) {
    margin-bottom: 24px;
  }
`
